import { useState } from "react";
import { MessageSquare, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function FeedbackTab() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLScyByQy-LMx5CqTcC_HE9g2ofBt4JgkUWKz01hOphelpMEYMw/viewform?embedded=true";
  const formUrl = user?.email
    ? `${baseUrl}&entry.1045781291=${encodeURIComponent(user.email)}`
    : baseUrl;

  return (
    <>
      {/* Floating button — bottom-right on mobile, right-edge tab on desktop */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed z-50 md:right-0 md:top-1/2 md:-translate-y-1/2 md:rounded-l-lg md:rounded-r-none md:px-2 md:py-4 md:writing-vertical bottom-4 right-4 md:bottom-auto bg-primary text-primary-foreground shadow-lg hover:opacity-90 transition-opacity rounded-full p-3 md:p-0"
          style={{ writingMode: undefined }}
        >
          {/* Mobile: icon only */}
          <MessageSquare className="h-5 w-5 md:hidden" />
          {/* Desktop: vertical text tab */}
          <span className="hidden md:flex items-center gap-1.5 text-xs font-semibold" style={{ writingMode: "vertical-lr" }}>
            <MessageSquare className="h-3.5 w-3.5 rotate-90" />
            Feedback
          </span>
        </button>
      )}

      {/* Feedback panel */}
      {open && (
        <div className="fixed z-50 inset-0 md:inset-auto md:right-0 md:top-0 md:h-full md:w-[400px] bg-background border-l shadow-xl flex flex-col">
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="font-semibold">Send Feedback</h3>
            <button onClick={() => setOpen(false)} className="p-1 rounded hover:bg-muted">
              <X className="h-5 w-5" />
            </button>
          </div>
          <iframe
            src={formUrl}
            className="flex-1 w-full bg-white"
            title="Feedback Form"
          />
        </div>
      )}
    </>
  );
}
